import React from 'react'

const PlusCircleIcon = () => {
	return (
		<svg width={25} height={25} viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M12.5 0C5.596 0 0 5.596 0 12.5S5.596 25 12.5 25 25 19.404 25 12.5 19.404 0 12.5 0zm4.834 11.373h-3.965v-4.15h-1.816v4.15H7.588v1.709h3.965v4.492h1.816v-4.492h3.965v-1.709z'
				fill='currentColor'
			/>
		</svg>
	)
}

export default PlusCircleIcon
